import * as angular from "angular";
import {IController} from "angular";

export class ServicePointsTableCtrl implements IController {

  public infiniteScroll: any;
  public sortField: string;
  public sortDirection: string;
  public onSortChanged: Function;
  public onEdit: Function;
  public onDelete: Function;

  public isScrollable: boolean;
  public asceDescIconsMap: any;

  /* @ngInject */
  constructor(private $mdMedia, private commonsConstants) {
  }

  $onInit() {
    this.asceDescIconsMap = this.commonsConstants.sortIconsMap;
  }

  $onChanges(changes: angular.IOnChangesObject) {
  }

  $doCheck() {
    this.isScrollable = !this.$mdMedia('gt-md');
  };

  onToggleSort(sortField) {
    const nextSortDirection = (this.sortField === sortField && this.sortDirection === 'asc') ? 'desc' : 'asc';
    this.onSortChanged({sortField: sortField, sortDirection: nextSortDirection});
  }

}

angular
  .module('bringoz.admin.service-points')
  .component('servicePointsTable', {
    bindings: {
      infiniteScroll: '<',
      sortField: '<',
      sortDirection: '<',
      branchIds: '<',
      onSortChanged: '&',
      onEdit: '&',
      onDelete: '&',
    },
    template: require('./service-points-table.html').default,
    controller: ServicePointsTableCtrl
  });
